import { AbstractAnalyticsTracker, NavigationToEnum } from '@inter-ikea-kompis/analytics';
import type { IDexfSettings } from '@inter-ikea-kompis/types';

import { IpexMomentEnum } from '@insights/insights-data-provider';

const moduleId = 'assembly_services';

/**
 * @event click When the button to open the zip in flow is clicked.
 * @event navigation When the read more link is clicked.
 */
export default class AssemblyServicesTracker extends AbstractAnalyticsTracker {
	constructor(options: {
		dev: boolean;
		ab?: boolean;
		settings: IDexfSettings;
		locale: string;
		reporterId?: string;
	}) {
		super({ moduleId, ...options });
	}

	public sendLearnMoreNavigation(): void {
		const payload = {
			common: { component: moduleId },
			data: {
				to: NavigationToEnum.ikeaAssembly
			}
		};

		this.getReporter().report({
			event: 'navigation',
			ipexMoment: IpexMomentEnum.helpMe,
			payload
		});
	}

	public sendAssemblyServicesClick(): void {
		this.getReporter().report({
			event: 'click',
			ipexMoment: IpexMomentEnum.showMe,
			payload: {
				common: { component: moduleId },
				data: {
					action: 'choose_location'
				}
			}
		});
	}
}
